const setCustomData = (customData: object|null) => ({
    type: 'SET_CUSTOM_DATA',
    customData
})

export default setCustomData